<template>
  <header id="page-header">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <img class="brand-logo" :src="$store.getters.getLogo" @click="logoClick" />
          <nav class="header-nav">
            <ul>
              <li class="active">Your Application</li>
            </ul>
          </nav>

          <div class="header-user" @click="hamburgerClick">
            <icon :icon="['far', 'bars']" />
          </div>
<!--
          <div class="header-user dropdown dropdown-right">
            <button type="button" class="dropdown-btn">
              michael@preapprovemeapp.com
            </button>
            <div class="dropdown-content">
              <a href="#">My Account</a>
              <a href="#">Log out</a>
            </div>
          </div>
-->
        </div>
      </div>
    </div>
  </header>
</template>

<script>
/* eslint-disable */
export default {
  name: 'Header',
  components: {},
  methods: {
    logoClick: function() {
      this.$store.dispatch('go', 'start')
    },
    hamburgerClick: function () {
      this.$emit('toggleDrawer')
    }
  }
}
</script>

<style scoped lang="scss">
header {
  .brand-logo {
    cursor: pointer;
//    background-image: url('../assets/logo_tmp.png');
  }

  .header-user {
    display: none !important;
    padding-left: 20px;
    font-size: 20px;
    
    @media (max-width: 992px) {
      display: inline-block !important;
    }
  }
}
</style>
